import cx from 'classnames';

import { EVL_MARK, INTERNAL_COBRAND_LOGOS } from '../config/catalogConfig';

interface CobrandLogoProps {
  partnerSlug: string;
  /** Podklad, na kterém logo stojí – řídí variantu značky (bílý vs. tmavý klín) a bílý filtr loga partnera. */
  tone?: 'dark' | 'light';
  className?: string;
}

/**
 * „eVlastníci + partner" – značka eVlastníci (jen grafika) + plus + logo partnera. Pro vlastní
 * služby poskytované v partnerství (Energetika s Veolií). Vrací null, když partner cobrand nemá.
 */
export const CobrandLogo: React.FC<CobrandLogoProps> = ({ partnerSlug, tone = 'dark', className }) => {
  const cobrand = INTERNAL_COBRAND_LOGOS[partnerSlug];
  if (!cobrand) return null;

  return (
    <span className={cx('CobrandLogo', `CobrandLogo--${tone}`, className)} aria-label={`eVlastníci + ${cobrand.partnerName}`}>
      <img src={EVL_MARK[tone]} alt="eVlastníci" className="CobrandLogo__mark" />
      <span className="CobrandLogo__plus">+</span>
      <img src={cobrand.partnerLogo} alt={cobrand.partnerName} className="CobrandLogo__partner" />
    </span>
  );
};

export default CobrandLogo;
